
<!-- <div class="table-responsive">      
  <table class="table table-striped">
    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th>Start</th>
        <th>End</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let event of events">
        @let media = event.media;
        <tr [style.border-left]="'4px solid ' + event.color" (click)="onEventClick(event)">
          <td>
            @let thumbnail = media?.thumbnail;
            @if (!!thumbnail) {
              <img [src]="thumbnail" alt="Event thumbnail" class="thumbnail" />
            } @else {
              <span *ngIf="!event.media?.thumbnail">-</span>
            }
          </td> 
          <td><span class="text-wrap-ellipsis">{{ event.name }}</span></td>
          <td>{{ formatDate(event.timeFrom) }}</td>
          <td>{{ formatDate(event.timeTo) }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div> -->

<div class="event-list">
  <ng-container *ngFor="let event of events">
    <!-- <div class="event" [style.border-left]="'4px solid ' + event.color" (click)="onEventClick(event)" [attr.aria-label]="'View details for ' + event.name"> -->
    <div class="event" 
        (click)="onEventClick(event)" 
        [attr.aria-label]="'View details for ' + event.name">
      <div class="d-flex align-items-center">
        <!-- Image -->
        <div class="thumbnail-container">
          @let thumbnail = event.media?.cover?.src;
          @if (!!thumbnail) {
            <img [src]="thumbnail | serverAuthUrl" alt="Event thumbnail" class="thumbnail" />
          } @else {
            <span class="thumbnail-placeholder">-</span>
          }
        </div>
        <!-- Text Rows -->
        <div class="flex-grow-1">
          <div class="name text-wrap-ellipsis">{{ event.name }}</div>
          <div class="details text-wrap-ellipsis">{{ formatDate(event.timeFrom) }} - {{ formatDate(event.timeTo) }}</div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
